import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { CharacterToolTip } from '@styles/match.style'
import ToolTipCharacter from '@assets/images/icon/matchup_icon/tool-tip-character.png'
import useRootStore from '@store/useRootStore'
import { MarketTrack } from '@store/matchupStore'

const TOOLTIP_CLASS = {
  SHOW: 'detail-tooltip-wrap show',
  HIDE: 'detail-tooltip-wrap',
}

export interface TooltipProps {
  market: MarketTrack
}

const MarketTooltip: React.FC<TooltipProps> = (props: TooltipProps) => {
  const { market } = props
  const { desc } = market
  const { marketTooltipStore } = useRootStore()
  const { marketTooltips } = marketTooltipStore
  const [tooltipClass, setTooltipClass] = useState(TOOLTIP_CLASS.HIDE)

  useEffect(() => {
    const active = marketTooltipStore.getActiveTooltip(market)
    const tooltip = active ? TOOLTIP_CLASS.SHOW : TOOLTIP_CLASS.HIDE
    setTooltipClass(tooltip)
  }, [marketTooltips?.[marketTooltipStore.getMarketTooltipKey(market)]])

  return (
    <CharacterToolTip className={tooltipClass}>
      <div className="bg"/>
      <img src={ToolTipCharacter} alt="툴팁 캐릭터" className="tooltip-img"/>
      <div className="tooltip-box">
        <pre className="tooltip-box--txt">
          {desc ? desc.ko : ''}
        </pre>
      </div>
    </CharacterToolTip>
  )
}


export default observer(MarketTooltip)
